import { auth, type SchemaResponse } from "@/modules/api"
import type {
  Address,
  CreateAddressInput,
  District,
  Province,
  UpdateAddressInput,
  Ward
} from "@/modules/types"
import type { PagingSchema } from "@/modules/types/common/schema"

// Get all addresses for current user
export const getAddresses = () => {
  return auth.get<SchemaResponse<Address[]>>("contacts/list")
}

// Get single address by ID
export const getAddressById = (id: string) => {
  return auth.get<SchemaResponse<Address>>(`contacts/${id}`)
}

// Create new address
export const createAddress = (data: CreateAddressInput) => {
  return auth.post<SchemaResponse<Address>>("contacts/create", data)
}

// Update existing address
export const updateAddress = (id: string, data: UpdateAddressInput) => {
  return auth.patch<SchemaResponse<Address>>(`contacts/update/${id}`, data)
}

// Delete address
export const deleteAddress = (id: string) => {
  return auth.delete<SchemaResponse<null>>(`contacts/delete/${id}`)
}

// Set address as default (Note: React Native has typo "contacts/create/${id}/default", using correct path)
export const setDefaultAddress = (id: string) => {
  return auth.patch<SchemaResponse<null>>(`contacts/${id}/default`)
}

// Location APIs
export const getProvinces = () => {
  return auth.get<SchemaResponse<PagingSchema<Province>>>("province/list", {
    params: {
      page: 1,
      take: 100
    }
  })
}

export const getDistricts = (provinceCode: string) => {
  return auth.get<SchemaResponse<PagingSchema<District>>>("district/list", {
    params: {
      provinceCode,
      page: 1,
      take: 100
    }
  })
}

export const getWards = (districtCode: string) => {
  return auth.get<SchemaResponse<PagingSchema<Ward>>>("ward/list", {
    params: {
      districtCode,
      page: 1,
      take: 100
    }
  })
}
